import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../loading/loading.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private readonly loading: LoadingService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.shouldTrack(req.url)) {
      this.loading.show();
      return next.handle(req).pipe(finalize(() => this.loading.hide()));
    }
    return next.handle(req);
  }

  private shouldTrack(url: string): boolean {
    return !url.includes('/assets/');
  }
}
